import axios from 'axios';
import md5 from 'js-md5';
import qs from 'qs';
import utils from '../utils/utils';

// 获取token
async function getToken(shopify) {
  const token = await shopify.idToken();
  return token;
}

// 请求拦截
axios.interceptors.request.use(async (request) => {
  // 安装校验
  if (request.url.indexOf('/shopify/app') !== -1) {
    return request
  }
  // 进行内嵌校验
  let shopify = window.shopify;
  // 判断是否内嵌
  if (shopify && shopify?.environment?.embedded) {
    try {
      return getToken(shopify).then(token => {
        request.headers['Authorization'] = `ShopifyBridge ${token}`;
        return request;
      })
    } catch (e) {
      console.error('Error fetching Shopify ID token:', e);
      return Promise.reject(e);
    }
  } else {
    const authToken = utils.getStore('authToken');
    if (authToken) {
      request.headers['Authorization'] = `ShopifyAdmin ${authToken}`;
    }
  }
  return request; // 返回完成
}, async (error) => {
  console.error('Request error:', error);
  return Promise.reject(error);
});


export async function ajax(url, data = {}, type = 'GET') {
  type = type.toUpperCase();
  // 默认的请求头
  let header;
  try {
    let response;
    if (type === 'GET') {
      response = await axios.get(url, {
        params: data,
        headers: header
      });
    } else if (type === 'POST') {
      let post = (url.indexOf('/api/v2/on-page/ckUpload') > -1) ? data : qs.stringify(data);
      response = await axios.post(url, post, {
        headers: header,
      });
    } else if (type === 'DELETE') {
      response = await axios.delete(url, {
        params: data,
        headers: header
      })
    } else {
      throw new Error(`Unsupported request type: ${type}`);
    }

    return response.data;
  } catch (error) {
    console.error('Request failed:', error);
    // 如果需要，可以在这里进一步处理错误
    throw error;
  }
}

export function ajaxWithoutAuth(url, data = {}, type = 'GET') {
  // 单独对外部接口做超时设置 --- 例: 谷歌速度分数检测
  axios.defaults.timeout = 60000;

  type = type.toUpperCase();

  return new Promise((resolve, reject) => {
    let promise;
    if (type === 'GET') {
      promise = axios.get(url, {
        params: data
      })
    }

    // POST 请求
    else if (type === 'POST') {
      promise = axios.post(url, qs.stringify(data))
    }

    // 请求成功
    promise.then(response => {
      resolve(response.data)
    });
  })
}

export function ajaxMiddleWithoutAuth(url, data = {}, type = 'GET') {

  type = type.toUpperCase();

  let timeStr = Date.parse(new Date()) / 1000;

  // console.log(md5("FPg9LRkHTj5j14ig7ETzQhG29r5sEWNR"+timeStr))

  let header = {
    "ACCESS-TYPE": "SAAPP",
    "Content-Type": "application/json; charset=utf-8",
    // 'ACCESS-TYPE': "application/json",
    "ACCESS-TOKEN": md5("VVOTT85HQDYXRIULMVNBXRVWLWCBBLZ0PFN2PQA7" + timeStr),
    "ACCESS-TIME": timeStr
  }

  return new Promise((resolve, reject) => {
    let promise;
    if (type === 'GET') {
      promise = axios.get(url, {
        params: data,
        headers: header
      },
      )
    }

    // POST 请求
    else if (type === 'POST') {
      promise = axios.post(url, qs.stringify(data), {
        headers: header
      })
    }

    // 请求成功
    promise.then(response => {
      resolve(response.data)
    })
  })
}

export function ajaxJSON(url, data = {}, type = 'GET') {

  type = type.toUpperCase();

  // let timeStr = Date.parse(new Date())/1000;
  let header = {
    "Content-Type": "application/json;charset=utf-8",
  }

  return new Promise((resolve, reject) => {
    let promise;
    if (type === 'GET') {
      promise = axios.get(url, {
        params: data,
        headers: header
      },
      )
    }

    // POST 请求
    else if (type === 'POST') {
      promise = axios.post(url, data, {
        headers: header
      })
    }

    // 请求成功
    promise.then(response => {
      resolve(response.data)
    })
  })
}